// Generated by scripts/build-ui-icons.mjs.
export { Armchair as default } from "../ui/glyphs-1";
